import { render, staticRenderFns } from "./modalExcelVentasPorArticulo.vue?vue&type=template&id=2cb9e2cd&"
import script from "./modalExcelVentasPorArticulo.vue?vue&type=script&lang=js&"
export * from "./modalExcelVentasPorArticulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports